import React from "react";
import { OrderRouteLayer } from "@src/features/order/components";
import { ErrorMapProps } from "./types";

const ErrorMap: React.FC<ErrorMapProps> = (props) => {
  const { order } = props;

  if (!order) return null;

  return <OrderRouteLayer order={order} droneVariant="error" />;
};

export default ErrorMap;
